/* FrostCar – petites améliorations par-dessus Dawn.
   Tout passe par les mécanismes natifs de Dawn (formulaire d'achat, tiroir panier). Pack de 2 = quantité 2. */
(() => {
  if (window.FC) return;
  window.FC = true;

  const money = (cents) => {
    const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
    try {
      return new Intl.NumberFormat('en-GB', { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) {
      return '£' + (cents / 100).toFixed(2);
    }
  };
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---------- 1. Choix du pack (page produit) : pack de 2 = quantité 2 ---------- */
  const getQtyInput = () => {
    const form = document.querySelector('product-form form');
    if (!form) return null;
    let inp = form.querySelector('input[name="quantity"]');
    if (!inp) {
      inp = document.createElement('input');
      inp.type = 'hidden';
      inp.name = 'quantity';
      form.appendChild(inp);
    }
    return inp;
  };

  function initBundles(wrap) {
    if (wrap.dataset.ready) return;
    wrap.dataset.ready = '1';
    const cards = [...wrap.querySelectorAll('.fc-opt')];

    const choose = (card) => {
      if (!card || card.disabled) return;
      cards.forEach((c) => {
        const on = c === card;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      const inp = getQtyInput();
      if (inp) inp.value = card.dataset.fcQty;
      const now = document.querySelector('[data-fc-price-now]');
      const sv = document.querySelector('[data-fc-price-save]');
      if (now) now.textContent = card.dataset.fcPrice;
      if (sv) {
        sv.hidden = !card.dataset.fcSave;
        sv.textContent = card.dataset.fcSave ? 'Save ' + card.dataset.fcSave : '';
      }
      updateSticky(card);
      document.dispatchEvent(new CustomEvent('fc:pack', { detail: card.dataset }));
    };

    wrap.addEventListener('click', (e) => {
      const card = e.target.closest('.fc-opt');
      if (card) choose(card);
    });

    // Au moment d'ajouter au panier : on force toujours la quantité du pack affiché
    document.addEventListener('submit', (e) => {
      const form = e.target;
      if (!form.closest || !form.closest('product-form')) return;
      const active = wrap.querySelector('.fc-opt.is-active');
      const inp = getQtyInput();
      if (active && inp) inp.value = active.dataset.fcQty;
    }, true);

    window.FCchoose = (qty) => {
      const card = cards.find((c) => c.dataset.fcQty === String(qty));
      if (card) choose(card);
      return !!card;
    };

    // Pack de départ : ?pack=2 dans l'URL, sinon le pack présélectionné
    const urlPack = new URLSearchParams(window.location.search).get('pack');
    const pre = cards.find((c) => c.dataset.fcQty === (urlPack || wrap.dataset.preselect)) || cards[0];
    choose(pre);
  }

  /* ---------- 2. Barre d'achat collée (mobile) ---------- */
  function updateSticky(card) {
    const bar = document.querySelector('[data-fc-sticky]');
    if (!bar || !card) return;
    bar.querySelector('[data-fc-sticky-name]').textContent = card.dataset.fcName;
    bar.querySelector('[data-fc-sticky-price]').textContent = card.dataset.fcPrice;
    bar.querySelector('[data-fc-sticky-note]').textContent = card.dataset.fcSave
      ? 'You save ' + card.dataset.fcSave
      : 'Free worldwide shipping';
  }

  function initSticky() {
    const bar = document.querySelector('[data-fc-sticky]');
    if (!bar || bar.dataset.ready) return;
    bar.dataset.ready = '1';
    document.body.appendChild(bar); // hors des conteneurs "sticky" de Dawn
    const getBtn = () => document.querySelector('product-form button[name="add"]');
    bar.querySelector('[data-fc-sticky-btn]').addEventListener('click', () => {
      const btn = getBtn();
      if (btn && !btn.disabled) btn.click();
      else document.getElementById('fc-bundles')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    const target = getBtn();
    if (!target || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(([en]) => {
      const show = !en.isIntersecting && en.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }).observe(target);
  }

  /* ---------- 3. Liens "choisir mon pack" (bannière, section packs) ---------- */
  document.addEventListener('click', (e) => {
    const pick = e.target.closest('[data-fc-pick]');
    const scroll = e.target.closest('[data-fc-scroll]');
    const bundles = document.getElementById('fc-bundles');
    if (!bundles || (!pick && !scroll)) return; // sur la page d'accueil : le lien mène à la page produit
    e.preventDefault();
    if (pick && window.FCchoose) window.FCchoose(pick.dataset.fcPick);
    bundles.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  /* ---------- 4. Tiroir panier : livraison offerte, pack de 2 ---------- */
  const PACK_OFF = 995; // remise par pièce dès 2 (doit = réduction automatique « 2-pack saving »)

  let enhancing = false;
  async function enhanceDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || enhancing) return;
    const inner = drawer.querySelector('.drawer__inner');
    if (!inner || inner.querySelector('.fc-mark')) return;
    enhancing = true;
    inner.insertAdjacentHTML('afterbegin', '<span class="fc-mark" hidden></span>');
    try {
      const empty = drawer.classList.contains('is-empty') || inner.classList.contains('is-empty');
      const header = inner.querySelector('.drawer__header');
      if (!empty && header && !inner.querySelector('.fc-ship')) {
        header.insertAdjacentHTML('afterend', `<div class="fc-ship">🚚 You've unlocked <b>free shipping</b></div>`);
      }
      if (empty) return;

      const cart = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      const box = inner.querySelector('.drawer__contents') || inner.querySelector('.drawer__footer');
      if (!box || inner.querySelector('.fc-up, .fc-saved')) return;

      const item = cart.items[0];
      if (item && cart.items.length === 1) {
        if (item.quantity === 1) {
          const single = item.final_price;
          const packTotal = (item.original_price - PACK_OFF) * 2;
          box.insertAdjacentHTML(
            'beforeend',
            `<div class="fc-up">
               <div class="fc-up__txt"><b>Add a 2nd for ${money(packTotal - single)}</b><span>Save ${money(item.original_price * 2 - packTotal)} · Perfect gift</span></div>
               <button type="button" class="fc-up__btn" data-key="${item.key}">+ Add</button>
             </div>`
          );
        } else if (cart.total_discount > 0) {
          box.insertAdjacentHTML(
            'beforeend',
            `<div class="fc-saved">🎉 You're saving <b>${money(cart.total_discount)}</b> with the 2-pack</div>`
          );
        }
      }
    } catch (e) {
      /* en cas d'erreur réseau, le tiroir Dawn reste fonctionnel tel quel */
    } finally {
      enhancing = false;
      const now = document.querySelector('cart-drawer .drawer__inner');
      if (now && !now.querySelector('.fc-mark')) setTimeout(enhanceDrawer, 60);
    }
  }

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.fc-up__btn');
    if (!btn) return;
    e.preventDefault();
    const drawer = document.querySelector('cart-drawer');
    btn.disabled = true;
    try {
      const res = await fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: btn.dataset.key, quantity: 2, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname })
      }).then((r) => r.json());
      if (drawer && res.sections && typeof drawer.renderContents === 'function') {
        drawer.renderContents(res);
      } else {
        window.location.reload();
      }
    } catch (err) {
      window.location.reload();
    }
  });

  function watchDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    let t;
    new MutationObserver(() => {
      clearTimeout(t);
      t = setTimeout(enhanceDrawer, 60);
    }).observe(drawer, { childList: true, subtree: true });
    enhanceDrawer();
  }

  /* ---------- Démarrage ---------- */
  const start = () => {
    initSticky();
    watchDrawer();
    document.querySelectorAll('[data-fc-bundles]').forEach(initBundles);
  };
  if (document.readyState === 'complete') start();
  else window.addEventListener('DOMContentLoaded', start, { once: true });
})();